import { SvgIconNames } from '@toggle/design-system';

export const getCatalystInsightIconProps = ({
  isBordered,
  isCompanyCatalyst,
  isDisabled,
}: {
  isBordered: boolean;
  isCompanyCatalyst?: boolean;
  isDisabled?: boolean;
}): {
  iconName: SvgIconNames;
  viewBox: string;
  fillColor: string;
} => {
  const catalystIconColor = isCompanyCatalyst
    ? 'var(--icon-decorative-lime)'
    : 'var(--icon-decorative-cyan)';
  return {
    iconName: isBordered ? 'Puzzle' : 'PuzzleBorderless',
    viewBox: isBordered ? '0 0 34 40' : '0 0 12 12',
    fillColor: isDisabled ? 'var(--icon-soft)' : catalystIconColor,
  };
};
